import api_fetch from '../utils/api_fetch';
import { storageHandler } from '../utils/storage_handler';
const account = {
  register: async function (body) {
    return (await api_fetch.post(`/v1/add-user`, {}, {}, '', body)).json();
  },
  login: async function (body) {
    return (await api_fetch.post(`/v1/login-user`, {}, {}, '', body)).json();
  },
  updateUser: async function (body) {
    return (
      await api_fetch.put(
        `/v1/modify-user`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        body
      )
    ).json();
  },
  getUser: async function () {
    return (
      await api_fetch.get(
        `/v1/get-user`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        {}
      )
    ).json();
  },

  createUser: async function (body) {
    return (
      await api_fetch.post(
        `/v1/add-user/`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        body
      )
    ).json();
  },

  updateUserById: async function (id, body) {
    return (
      await api_fetch.put(
        `/v1/users/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        body
      )
    ).json();
  },

  deleteUserById: async function (id) {
    return (
      await api_fetch.put(
        `/v1/users/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        { is_active: false, deleted_at: new Date() }
      )
    ).json();
  }
};
export default account;
